import React, { useState } from 'react'
import { useSortBy, UseSortByProps } from 'react-instantsearch-core'

export const Sort = (props: UseSortByProps) => {
  const { currentRefinement, options, refine } = useSortBy(props)

  const [refined, setRefined] = useState<string>(currentRefinement)

  function changeSort(e: string) {
    setRefined(e)
    refine(e)
  }

  return (
    <div className="Algolia-sortContainer">
      <label className="Algolia-sortLabel">Sort by</label>

      {options?.length > 0 ? (
        <div className="Algolia-sorts">
          {options.map((item, i) => (
            <button
              key={i}
              className={`Algolia-sort ${
                refined === item.value ? 'active' : ''
              } `}
              onClick={() => changeSort(item.value)}
            >
              {item.label}
            </button>
          ))}
        </div>
      ) : (
        ''
      )}
    </div>
  )
}
